import { Component, inject, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { UserInterface } from 'voxr-shared';
import { UserService } from '../../../services/user.service';
import { clone } from '../../../utility';
import { MatCardModule } from '@angular/material/card';
import { AppService } from '../../../services/app.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    MatCardModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule
  ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent {
  private userService = inject(UserService);
  private app = inject(AppService);
  
  saved = output<UserInterface>();
  
  user?: UserInterface | null;
  loading = false;

  isComplete = false;

  constructor() {
    this.userService.user$.pipe(takeUntilDestroyed()).subscribe(user => {
      this.loadUser(user);
    });
  }

  private loadUser(user?: UserInterface | null) {
    this.user = clone(user) as UserInterface;
    if (this.user) {
      if (!this.user.profile)
        this.user.profile = {};

      const profile = this.user?.profile;
      if (!profile['firstName']) profile['firstName'] = profile['name']?.split(' ')[0] || '';

      this.isComplete = !!this.user.isEmailVerified && !!this.user.phone &&
        !!profile['firstName'] && !!profile['lastName'] && !!profile['company'];
    }
  }

  saving = false;
  async updateProfile() {
    try {
      this.saving = true;
      this.user = await this.userService.updateProfile(this.user!);
      this.saved.emit(this.user!);
      this.app.message$.next({ severity: 'success', summary: 'Profile Updated', detail: 'Your profile has been updated' });
    } catch (e) {
      this.app.message$.next({ severity: 'danger', summary: 'Profile Update Failed', detail: 'There was an error updating your profile' });
    } finally {
      this.saving = false;
    }
  }

  sendingVerificationEmail = false;
  async sendVerificationEmail() {
    try {
      this.sendingVerificationEmail = true;
      await this.app.sendEmailVerificationIfRequired();
    } finally {
      this.sendingVerificationEmail = false;
    }
  }

}
